import React from 'react';

/**
 * Left chevron icon for previous navigation
 * viewBox cropped to arrow bounds (9,6)–(15,18). 12×24 restores original arrow size; stroke matches X (20/24 px).
 */
export const ChevronLeft = () => (
    <svg 
        width="12" 
        height="24" 
        viewBox="9 6 6 12" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth={5 / 12}
        strokeLinecap="round" 
        strokeLinejoin="round"
    >
        <polyline points="15 18 9 12 15 6" />
    </svg>
);

/**
 * Right chevron icon for next navigation
 * viewBox cropped to arrow bounds (9,6)–(15,18). 12×24 restores original arrow size; stroke matches X (20/24 px).
 */
export const ChevronRight = () => (
    <svg 
        width="12" 
        height="24" 
        viewBox="9 6 6 12" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth={5 / 12}
        strokeLinecap="round" 
        strokeLinejoin="round"
    >
        <polyline points="9 18 15 12 9 6" />
    </svg>
);

/**
 * Close (X) icon for closing the viewer
 */
export const CloseIcon = () => (
    <svg 
        width="20" 
        height="20" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="1" 
        strokeLinecap="round" 
        strokeLinejoin="round"
    >
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
);

export const PlayIcon = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
    >
        <path d="M8 5v14l11-7z" />
    </svg>
);

export const PauseIcon = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
    >
        <path d="M7 5h3v14H7zM14 5h3v14h-3z" />
    </svg>
);

/**
 * Double chevron left for onboarding swipe hint
 */
export const DoubleChevronLeft = ({ style, className }) => (
    <svg 
        width="42" 
        height="42" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="1" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        style={style}
        className={className}
    >
        <polyline points="11 17 6 12 11 7" />
        <polyline points="18 17 13 12 18 7" />
    </svg>
);

/**
 * Double chevron right for onboarding swipe hint
 */
export const DoubleChevronRight = ({ style, className }) => (
    <svg 
        width="42" 
        height="42" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="1" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        style={style}
        className={className}
    >
        <polyline points="13 17 18 12 13 7" />
        <polyline points="6 17 11 12 6 7" />
    </svg>
);

/**
 * Double chevron down for onboarding swipe-to-close hint
 */
export const DoubleChevronDown = ({ style, className }) => (
    <svg 
        width="42" 
        height="42" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="1" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        style={style}
        className={className}
    >
        <polyline points="7 8 12 13 17 8" />
        <polyline points="7 14 12 19 17 14" />
    </svg>
);
